/** Marks the element a `ViewTable` scrolls inside. */
export const VIEW_TABLE_SCROLL_ROOT_ATTRIBUTE = "data-view-table-scroll-root";

export const VIEW_TABLE_SCROLL_ROOT_SELECTOR = `[${VIEW_TABLE_SCROLL_ROOT_ATTRIBUTE}]`;
